var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    name: "downArrow",
    className: "downArrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.034,
    height: 5.724,
    viewBox: "0 0 10.034 5.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "none",
    stroke: "#0072c6",
    strokeMiterlimit: 10,
    d: "M0,9.327,4.663,4.664,0,0",
    transform: "translate(9.681 0.354) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.0cc010b602ead830de388b8f7f4ce394.svg";
export { ForwardRef as ReactComponent };